export default __webpack_public_path__ + "static/media/logo.99baff09.svg";